import { cn } from '@/lib/utils'
import { Typo3Section } from '@/types/typo3'
import { Base } from '@/ui/components'
import React, { memo } from 'react'
import { BaseProps } from '../types'

export interface SectionProps extends BaseProps {
  data?: Typo3Section
  children?: React.ReactNode
}

const Section = ({
  className,
  children,
  id,
  as = 'section',
  data,
  ...props
}: SectionProps) => {
  const sectionId = data?.id || id
  const spaceBefore = data?.appearance?.spaceBefore || ''
  const spaceAfter = data?.appearance?.spaceAfter || ''

  const sectionClasses = cn(className, 'section', 'py-3xl', {
    'pt-0!': spaceBefore === 'none',
    'pt-md!': spaceBefore === 's',
    'pt-xl!': spaceBefore === 'm',
    'pt-3xl!': spaceBefore === 'l',
    'pb-0!': spaceAfter === 'none',
    'pb-md!': spaceAfter === 's',
    'pb-xl!': spaceAfter === 'm',
    'pb-3xl!': spaceAfter === 'l'
  })

  return (
    <>
      {data?.anchors?.hasOther && (
        <div data-slot="section-anchor" id={data?.anchors?.other} />
      )}
      <Base
        as={as}
        id={sectionId ? `c${sectionId}` : undefined}
        className={sectionClasses}
        {...props}
      >
        {children}
      </Base>
    </>
  )
}

Section.displayName = 'Section'

export default memo(Section)
